import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export interface TrackPromoTileClickProps extends DeferredNavigationProps {
  data: {
    interactionLocation: string;
    linkUrl: string;
    index: number;
    carouselSlideName: string;
    coOpBrand: string | null;
    tileCount: number;
  };
}

export const trackPromoTileClick = ({
  data,
  ...deferral
}: TrackPromoTileClickProps) => {
  const {
    interactionLocation,
    linkUrl,
    index,
    carouselSlideName,
    coOpBrand,
    tileCount,
  } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_promo_tiles',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        index: index.toString(),
        carousel_slide_name: carouselSlideName,
        coop_brand: coOpBrand,
        type: `${tileCount} across`,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
